'use client'

import { smartSRPMessages } from '@/src/utils/srp/aiRecommendation/locale'
import { Box, Typography } from '@mui/material'
import { useLocale } from 'next-intl'
import { memo, useCallback, useEffect, useMemo, useRef, useState } from 'react'


const CYCLE_INTERVAL_MS = 3000
const ANIMATION_DURATION_MS = 400

const AnimatedPlaceholder = memo(function AnimatedPlaceholder () {
    const locale = useLocale() as 'en' | 'ar'
    const HINTS = useMemo(() => {
        return smartSRPMessages[locale]?.smartSearchPlaceHolderHints || []
    }, [locale])
    const [activeIndex, setActiveIndex] = useState(0)
    const [isAnimating, setIsAnimating] = useState(false)
    const timerRef = useRef<ReturnType<typeof setInterval> | null>(null)

    const advance = useCallback(() => {
        setIsAnimating(true)
        setTimeout(() => {
            setActiveIndex(prev => (prev + 1) % HINTS.length)
            setIsAnimating(false)
        }, ANIMATION_DURATION_MS)
    }, [HINTS])

    useEffect(() => {
        timerRef.current = setInterval(advance, CYCLE_INTERVAL_MS)
        return () => {
            if (timerRef.current) clearInterval(timerRef.current)
        }
    }, [advance, HINTS])

    return (
        <Box
            sx={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'flex-start',
                pointerEvents: 'none',
                overflow: 'hidden',
                p: '8.5px 14px',
            }}
        >
            <Box sx={{ overflow: 'hidden', width: '100%' }}>
                <Typography
                    variant="body2"
                    sx={{
                        color: 'text.disabled',
                        fontSize: '0.875rem',
                        lineHeight: 1.5,
                        whiteSpace: 'normal',
                        transition: `opacity ${ANIMATION_DURATION_MS}ms ease, transform ${ANIMATION_DURATION_MS}ms ease`,
                        opacity: isAnimating ? 0 : 1,
                        transform: isAnimating ? 'translateY(-8px)' : 'translateY(0)',
                    }}
                >
                    {HINTS[activeIndex]}
                </Typography>
            </Box>
        </Box>
    )
})

export default AnimatedPlaceholder
